import { Component, Output, EventEmitter } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { HeaderComponent } from "../components/header/header.component";
import { SidebarComponent } from "../components/sidebar/sidebar.component";
import { SubheaderComponent } from "../components/subheader/subheader.component";
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { CalendarModule } from "primeng/calendar";
import { ButtonModule } from "primeng/button";
import { InputNumberModule } from "primeng/inputnumber";

@Component({
  selector: "app-loan-use",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HeaderComponent,
    SidebarComponent,
    SubheaderComponent,
    DropdownModule,
    InputTextModule,
    InputTextareaModule,
    CalendarModule,
    ButtonModule,
    InputNumberModule
  ],
  templateUrl: "./loan-use.component.html",
  styleUrl: "./loan-use.component.css",
})
export class LoanUseComponent {
  @Output() backToWelcome = new EventEmitter<void>();
  @Output() navigateToNext = new EventEmitter<void>();

  loanUseForm: FormGroup;

  // Opciones para el dropdown "¿Para qué utilizarás tu préstamo?"
  purposeOptions = [
    { label: 'Pagar un servicio', value: 'service_payment' },
    { label: 'Gastos médicos', value: 'medical_expenses' },
    { label: 'Educación', value: 'education' },
    { label: 'Mejoras del hogar', value: 'home_improvement' },
    { label: 'Consolidación de deudas', value: 'debt_consolidation' },
    { label: 'Emergencia', value: 'emergency' },
    { label: 'Negocio', value: 'business' },
    { label: 'Otro', value: 'other' }
  ];

  // Opciones para el dropdown "¿Qué tipo de gasto?"
  expenseTypeOptions = [
    { label: 'Gasto fijo', value: 'fixed_expense' },
    { label: 'Gasto variable', value: 'variable_expense' },
    { label: 'Inversión', value: 'investment' },
    { label: 'Emergencia', value: 'emergency' },
    { label: 'Lujo', value: 'luxury' }
  ];

  // Opciones para el dropdown "¿Desde donde estás realizando tu solicitud?"
  locationOptions = [
    { label: 'Casa', value: 'home' },
    { label: 'Oficina', value: 'office' },
    { label: 'Café/Restaurante', value: 'cafe_restaurant' },
    { label: 'Transporte público', value: 'public_transport' },
    { label: 'Centro comercial', value: 'shopping_center' },
    { label: 'Otro', value: 'other' }
  ];

  constructor(private router: Router, private fb: FormBuilder) {
    this.loanUseForm = this.fb.group({
      purpose: [null, [Validators.required]],
      expenseType: [null, [Validators.required]],
      location: [null, [Validators.required]],
      debtPercentage: [null, [Validators.required, Validators.min(0), Validators.max(100)]]
    });
  }

  // Método para verificar si un campo es inválido
  isFieldInvalid(fieldName: string): boolean {
    const field = this.loanUseForm.get(fieldName);
    return !!(field && field.invalid && (field.dirty || field.touched));
  }

  // Método para obtener el mensaje de error de un campo
  getFieldError(fieldName: string): string {
    const field = this.loanUseForm.get(fieldName);
    if (field && field.errors && (field.dirty || field.touched)) {
      if (field.errors['required']) {
        return 'Este campo es requerido';
      }
      if (field.errors['min']) {
        return 'El valor mínimo es 0';
      }
      if (field.errors['max']) {
        return 'El valor máximo es 100';
      }
    }
    return '';
  }

  // Método para marcar todos los campos como tocados
  markAllFieldsAsTouched(): void {
    Object.keys(this.loanUseForm.controls).forEach(key => {
      this.loanUseForm.get(key)?.markAsTouched();
    });
  }

  goBack(): void {
    this.router.navigate(['/business-data']);
  }

  onSubmit(): void {
    if (this.loanUseForm.valid) {
      console.log('Uso del préstamo enviado:', this.loanUseForm.value);
      this.router.navigate(['/first-reference']);
    } else {
      this.markAllFieldsAsTouched();
      console.log('Formulario inválido');
    }
  }
}
